<p class="toast_card warning_msg" *ngIf="msg"><i class="icon-info"></i>{{msg}}</p>